<div class="scrollable-wrapper">
  <div class="company-create-page">
    <edit-company
      *ngIf="!!formGroup"
      [organization]="organization"
      [company]="company"
      [formGroup]="formGroup"
      [isFirstCompany]="!!firstCompanyId"
      (createCompanySource$)="redirectToView($event)"
    ></edit-company>
  </div>
</div>
